import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { TranslateModule } from '@ngx-translate/core';
import { ServiceWorkerService } from '../../../../core/services/service-worker.service';

@Component({
  selector: 'app-unsupported-browser',
  template: `
    @if (!isServiceWorkerSupported()) {
      <zenith-notification
        class="mx-3 my-3"
        zn-appearance="error"
        [attr.zn-heading]="'components.common.unsupported-browser.title' | translate"
        zn-open>
        <zenith-notification-content>{{ 'components.common.unsupported-browser.message' | translate }}</zenith-notification-content>
      </zenith-notification>
    }
  `,
  imports: [ZenithComponentsModule, TranslateModule],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnsupportedBrowserComponent {
  private readonly serviceWorkerService = inject(ServiceWorkerService);

  readonly isServiceWorkerSupported = computed(() => this.serviceWorkerService.isSupported());
}
